import styled from "styled-components";

export const ImageCardContainer = styled.div`
	width: 20rem;
	height: 27rem;
	grid-template-rows: 8fr 2fr;
	grid-gap: 1rem;
`;

export const ImageContainer = styled.div`
	img {
		width: 100%;
		height: 25rem;
	}
`;
export const Title = styled.p`
	text-align: center;
	font-size: 1.5rem;
`;
